import Swal from 'sweetalert2';

const base = {
  customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-light ms-2', popup: 'rounded-4' },
  buttonsStyling: false,
};

export const alertSucesso  = (t, m)  => Swal.fire({ ...base, icon: 'success', title: t, text: m });
export const alertErro     = (t, m)  => Swal.fire({ ...base, icon: 'error',   title: t, text: m });
export const alertAviso    = (t, m)  => Swal.fire({ ...base, icon: 'warning', title: t, text: m });
export const alertConfirmar = async (t, m) => {
  const r = await Swal.fire({ ...base, icon: 'question', title: t, text: m, showCancelButton: true, confirmButtonText: 'Confirmar', cancelButtonText: 'Cancelar' });
  return r.isConfirmed;
};
